import type { InfiniteData } from '@tanstack/react-query'

import type { PaginatedModeration } from '@tribeplatform/gql-client/types'

import type { QueryClient } from '../../lib/react-query/QueryClient.js'
import {
  getModerationItemsKey,
  getPostModerationItemsKey,
} from '../../utils/keys/moderation.key.js'

export const removeFromModerationItems = (
  moderationItemId: string,
  queryClient: QueryClient,
) => {
  const moderationItemsKey = getModerationItemsKey()
  queryClient.setQueriesData<InfiniteData<PaginatedModeration>>(
    moderationItemsKey,
    old => ({
      ...old,
      pages: old?.pages?.map(page => ({
        ...page,
        edges: page?.edges?.filter(edge => edge.node.id !== moderationItemId),
        nodes: page?.nodes?.filter(node => node.id !== moderationItemId),
      })),
    }),
  )

  const postModerationItemsKey = getPostModerationItemsKey()
  queryClient.setQueriesData<InfiniteData<PaginatedModeration>>(
    postModerationItemsKey,
    old => ({
      ...old,
      pages: old?.pages?.map(page => ({
        ...page,
        edges: page?.edges?.filter(edge => edge.node.id !== moderationItemId),
        nodes: page?.nodes?.filter(node => node.id !== moderationItemId),
      })),
    }),
  )
}
